import { submitBtnAnimation } from './submit-btn.anim';
import tarefeAnim from './tarefe.anim';
import { overlayFade } from './_overlay.anim';
import { fadeInFadeOutAnimation } from './fadein-fadeout.anim';

export const printOrderAnimations = [
  fadeInFadeOutAnimation ,
  submitBtnAnimation,
  overlayFade,
  tarefeAnim,
];

export * from './route-animations';
